import React, { useState, useEffect } from "react";
import "./index.scss";

type MenuTabProps = {
  items: Array<any>;
  initialIndex?: number;
  onTabChanged?: (index: number) => void;
  embedMode?: boolean;
};

const MenuTab = ({
  items,
  initialIndex = 0,
  onTabChanged = () => {},
  embedMode,
}: MenuTabProps) => {
  const [index, setIndex] = useState(initialIndex);
  useEffect(() => {
    onTabChanged(index);
  }, [index]);
  return (
    <div className="base-map__menu-tab__container">
      <div className="base-map__menu-tab__tab-header">
        {items.map((item, idx) => {
          const isActive = index == idx;
          return (
            <div
              key={item.icon}
              className="base-map__menu-tab__tab-label"
              onClick={() => setIndex(idx)}
            >
              <i
                className={`material-icons tab-icon ${
                  isActive && "tab-icon-active"
                }`}
              >
                {item.icon}
              </i>
              {isActive && <div className="bottom-line" />}
            </div>
          );
        })}
      </div>
      <div
        className={`base-map__menu-tab__tab-item${
          embedMode ? " menu-tab__embed-mode" : ""
        }`}
      >
        {items?.[index]?.scene}
      </div>
    </div>
  );
};

export default MenuTab;
